<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="SIM卡号/ICCID" style="width: 200px; margin-right: 3px;"></Input>
      <DatePicker size="small" type="daterange" v-model="selectCreateDatetime" placeholder="创建时间"
                  style="margin-right: 3px; width: 200px;"></DatePicker>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onExportExcelClick">导出</Button>

      <Button type="primary" size="small" style="margin-right: 3px;" @click="addSimInfoModal=true">添加SIM卡信息</Button>
<!--      <Upload style="display: inline-block;max-height: 23.99px;margin-right: 3px;" :on-success="onUploadSuccess" action="/api/im/siminfo/uploadsiminfosfile">-->
<!--        <Button size="small" type="primary">批量导入SIM卡信息</Button>-->
<!--      </Upload>-->
      <Button size="small" type="primary" style="margin-right: 3px;" @click="uploadExcel=true">批量导入SIM卡信息</Button>
      <Button v-if="simInfoList.length > 1" type="primary" size="small" style="margin-right: 3px;" @click="simInfoChangeInstallerModal=true">批量绑定师傅</Button>
      <Button v-if="simInfoList.length > 1" type="primary" size="small" style="margin-right: 3px;" @click="simInfoChangeUsergroupModal=true">批量分配分组</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange" @contextmenu.prevent.native="onTableRightClick($event)"
                 @on-selection-change="onselectionchange"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <add-sim-info-modal v-model="addSimInfoModal" @on-success="onSuccess"></add-sim-info-modal>
    <sim-info-detail-modal v-model="simInfoDetailModal" :initValue="simInfoDetailId"
                                     @on-success="onModifySuccess"></sim-info-detail-modal>
    <sim-info-change-installer-modal v-model="simInfoChangeInstallerModal" :initValue="simInfoChangeInstallerId" :listValue="simInfoList" @on-success="onModifySuccess"></sim-info-change-installer-modal>
    <sim-info-change-usergroup-modal v-model="simInfoChangeUsergroupModal" :initValue="simInfoChangeUsergroupId" :listValue="simInfoList" @on-success="onModifySuccess"></sim-info-change-usergroup-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal" @on-column-update="onColumnUpdate"></web-table-columns-modal>

    <Modal
      v-model="uploadExcel"
      title="批量导入SIM卡信息"
      @on-ok="ok"
      @on-cancel="cancel"
      cancel-text=""
      width="300">

      <Upload style="display: inline-block;max-height: 23.99px;margin-right: 3px;" :on-success="onUploadSuccess" action="/api/im/siminfo/uploadsiminfosfile">
        <Button size="small" type="primary">选择文件</Button>
      </Upload>

      <Button v-if="EXCELSrc" type="primary" size="small" @click="downloadTemple(EXCELSrc)" style="margin: 10px;">下载导入模板</Button>

    </Modal>

  </div>
</template>

<script>
import AddSimInfoModal from '@/view/im/components/add-sim-info-modal'
import SimInfoDetailModal from '@/view/im/components/sim-info-detail-modal'
import SimInfoChangeInstallerModal from '@/view/im/components/sim-info-change-installer-modal'
import SimInfoChangeUsergroupModal from '@/view/im/components/sim-info-change-usergroup-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'
import { genURLParams } from '@/libs/urlparamhelper'

export default {
  name: 'siminfos',
  components: {
    AddSimInfoModal,
    SimInfoDetailModal,
    SimInfoChangeInstallerModal,
    SimInfoChangeUsergroupModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      operationFilter: null,
      stateFilter: null,

      simStateOptions: [
        { label: '未安装', value: 0 },
        { label: '已安装', value: 1 },
        { label: '停用', value: 2 }
      ],
      simOperationOptions: [
        { label: '中国移动', value: 1 },
        { label: '中国联通', value: 2 },
        { label: '中国电信', value: 3 },
        { label: '珠海移动专网', value: 4 },
        { label: '中国移动-东莞中智', value: 5 },
        { label: '中国移动-佛山交协', value: 6 },
        { label: '中国电信-中山邦悦', value: 7 },
        { label: '中国移动-河北九宸', value: 8 },
        { label: '中国移动-中山邦悦', value: 9 },
        { label: '中国联通-中山邦悦', value: 10 },
        { label: '中国移动-深圳晓聪', value: 11 }
      ],

      // 添加收入项
      addSimInfoModal: false,

      // SIM卡信息详细信息
      simInfoDetailModal: false,
      simInfoDetailId: null,

      uploadExcel: false,
      // 导入模板地址
      EXCELSrc: '/ERP/im/upload-simExcel.xlsx',

      // SIM卡绑定安装维修员
      simInfoChangeInstallerModal: false,
      simInfoChangeInstallerId: null,
      // SIM卡分配分组
      simInfoChangeUsergroupModal: false,
      simInfoChangeUsergroupId: false,
      simInfoList: [],

      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      selectCreateDatetime: [],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      installerFilter: null,
      userGroupFilter: null,

      installers: [],

      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 70
        },
        {
          title: 'SIM卡号',
          resizable: true,
          key: 'simNum',
          ellipsis: 'true',
          width: 150
        },
        {
          title: 'SIM卡11位号码',
          resizable: true,
          key: 'simShortNum',
          ellipsis: 'true',
          width: 150
        },
        {
          title: 'ICCID',
          resizable: true,
          key: 'iccid',
          ellipsis: 'true',
          width: 190
        },
        {
          title: '运营商',
          resizable: true,
          key: 'operation',
          ellipsis: 'true',
          width: 150,
          filters: [
            { label: '中国移动', value: 1 },
            { label: '中国联通', value: 2 },
            { label: '中国电信', value: 3 },
            { label: '珠海移动专网', value: 4 },
            { label: '中国移动-东莞中智', value: 5 },
            { label: '中国移动-佛山交协', value: 6 },
            { label: '中国电信-中山邦悦', value: 7 },
            { label: '中国移动-河北九宸', value: 8 },
            { label: '中国移动-中山邦悦', value: 9 },
            { label: '中国联通-中山邦悦', value: 10 },
            { label: '中国移动-深圳晓聪', value: 11 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.operationFilter = genQueryParam('operation', 'EQ', val[0])
            } else {
              this.operationFilter = null
            }
          },
          render: function (h, params) {
            let operation = params.row.operation
            if (operation === 1) {
              return h('div', '中国移动')
            } else if (operation === 2) {
              return h('div', '中国联通')
            } else if (operation === 3) {
              return h('div', '中国电信')
            } else if (operation === 4) {
              return h('div', '珠海移动专网')
            } else if (operation === 5) {
              return h('div', '中国移动-东莞中智')
            } else if (operation === 6) {
              return h('div', '中国移动-佛山交协')
            } else if (operation === 7) {
              return h('div', '中国电信-中山邦悦')
            } else if (operation === 8) {
              return h('div', '中国移动-河北九宸')
            } else if (operation === 9) {
              return h('div', '中国移动-中山邦悦')
            } else if (operation === 10) {
              return h('div', '中国联通-中山邦悦')
            } else if (operation === 11) {
              return h('div', '中国移动-深圳晓聪')
            }
          }
        },
        {
          title: 'SIM卡状态',
          resizable: true,
          key: 'state',
          ellipsis: 'true',
          width: 130,
          filters: [
            { label: '未安装', value: 0 },
            { label: '已安装', value: 1 },
            { label: '停用', value: 2 },
            { label: '待停用', value: 3 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.stateFilter = genQueryParam('state', 'EQ', val[0])
            } else {
              this.stateFilter = null
            }
          },
          render: function (h, params) {
            let state = params.row.state
            if (state === 0) {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    color: 'blue'
                  }
                }, '未安装')
              ])
            } else if (state === 1) {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    color: 'green'
                  }
                }, '已安装')
              ])
            } else if (state === 2) {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    color: 'red'
                  }
                }, '停用')
              ])
            } else if (state === 3) {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    color: 'yellow'
                  }
                }, '待停用')
              ])
            }
          }
        },
        {
          title: '分组',
          resizable: true,
          key: 'userGroup',
          // sortable: 'custom',
          ellipsis: 'true',
          width: 120,
          filters: [
            { label: '中山', value: 1 },
            { label: '江门', value: 2 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.userGroupFilter = []
              val.forEach(item => {
                if (item == null) {
                  this.userGroupFilter.push(genQueryParam('userGroupId', 'EQNULL'))
                } else {
                  this.userGroupFilter.push(genQueryParam('userGroupId', 'EQ', item))
                }
              })
            } else {
              this.userGroupFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            if (params.row.userGroup) {
              return h('div', params.row.userGroup.name)
            } else {
              return h('div', '未分配')
            }
          }
        },
        {
          title: '分配师傅',
          resizable: true,
          key: 'installer',
          ellipsis: 'true',
          width: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.installerFilter = []
              val.forEach(item => {
                if (item == null) {
                  this.installerFilter.push(genQueryParam('installerId', 'EQNULL'))
                } else {
                  this.installerFilter.push(genQueryParam('installerId', 'EQ', item))
                }
              })
            } else {
              this.installerFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            if (params.row.installerId) {
              return h('div', params.row.installer.realName != null ? params.row.installer.realName : params.row.installer.nickName != null ? params.row.installer.nickName : params.row.installer.name)
            } else {
              return h('div', {
                style: {
                  color: 'red'
                }
              }, '未分配')
            }
          }
        },
        {
          title: '安装设备',
          resizable: true,
          key: 'positioningDeviceInfoId',
          ellipsis: 'true',
          width: 180,
          render: function (h, params) {
            if (!params.row.positioningDeviceInfoId) {
              return h('div', '无')
            }
            return h('div', params.row.positioningDeviceInfo.terminalNum)
          }
        },
        {
          title: '安装车辆',
          resizable: true,
          key: 'positioningDeviceInfoId',
          ellipsis: 'true',
          width: 180,
          render: function (h, params) {
            if (!params.row.positioningDeviceInfo || !params.row.positioningDeviceInfo.vehicleInfo) {
              return h('div', '无')
            }
            let vehicleInfo = params.row.positioningDeviceInfo.vehicleInfo
            let display = null
            if (vehicleInfo.registrationNum) {
              display = vehicleInfo.registrationNum
            } else {
              display = vehicleInfo.vin
            }
            if (vehicleInfo.customName) {
              display = display + '(' + vehicleInfo.customName + ')'
            }
            return h('div', display)
          }
        },
        {
          title: '备注',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          key: 'remark',
          width: 180
        },
        {
          title: '历史记录',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'historyRecord',
          width: 200
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 220,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.simInfoDetailId = params.row.id
                    this.simInfoDetailModal = true
                  }
                }
              }, '详细信息'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.handleSelectAll(false)
                    this.simInfoChangeInstallerId = params.row.id
                    this.simInfoChangeInstallerModal = true
                  }
                }
              }, '绑定师傅'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.handleSelectAll(false)
                    this.simInfoChangeUsergroupId = params.row.id
                    this.simInfoChangeUsergroupModal = true
                  }
                }
              }, '分配分组')
            ])
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'SimInfoServ_GetPage'
    ]),
    /**
     * 批量选择功能
     */
    onselectionchange (selection) {
      console.log(selection)
      this.simInfoList = selection
      // if (selection.length > 0) {
      //   selection.forEach(item => {
      //     this.installOrderIds.push(item.id)
      //   })
      // }else {
      //   this.installOrderIds = []
      // }
      // console.log(this.simInfoList.length)
    },
    handleSelectAll (status) {
      this.$refs.table.selectAll(status)
    },
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onUploadSuccess () {
      this.setPage(this.pageIndex)
    },
    downloadTemple (e) {
      console.log(e)
      window.location.href = e
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage()
    },
    onFilterClick () {
      this.setPage(1)
    },
    onExportExcelClick () {
      console.log(this.keywordFilter)
      let queryParams = []
      if (this.selectCreateDatetime[0] && this.selectCreateDatetime[1]) {
        let startDatetime = new Date(this.selectCreateDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectCreateDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
      }
      let qo1 = null
      let qo2 = null

      if (this.installerFilter) {
        qo1 = this.installerFilter
      }

      if (this.userGroupFilter) {
        qo2 = this.userGroupFilter
      }
      let urlparams = {
        q: queryParams,
        qo1: qo1,
        qo2: qo2,
        keyword: this.keywordFilter
      }
      let url = '/api/im/siminfo/getexcelreport' + genURLParams(urlparams)
      window.location.href = url
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    filterChange () {
      this.refreshPage()
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let sortParam = null
      let qo1 = null
      let qo2 = null

      if (this.installerFilter) {
        qo1 = this.installerFilter
      }

      if (this.userGroupFilter) {
        qo2 = this.userGroupFilter
      }

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      if (this.operationFilter) {
        queryParams.push(this.operationFilter)
      }
      if (this.stateFilter) {
        queryParams.push(this.stateFilter)
      }
      if (this.selectCreateDatetime[0] && this.selectCreateDatetime[1]) {
        let startDatetime = new Date(this.selectCreateDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectCreateDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
      }

      store.dispatch('SimInfoServ_GetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          qo2: qo2,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '分配师傅') {
          this.columns[i].filters = this.installers
          break
        }
      }
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_SimInfo_GetPageResult) {
        return store.getters.get_SimInfo_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_SimInfo_GetPageResult) {
        return store.getters.get_SimInfo_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_SimInfo_GetPageResult) {
        return store.getters.get_SimInfo_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [8, 14] }
      }).then(() => {
        let installers = store.getters.get_User_GetAllUsersResult
        this.installers = installers.map(item => {
          return { label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id }
        })
        this.onColumnUpdate()
      }).catch(err => {
        this.$Message.error(err)
      })

      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>

</style>
